import { ITipoParcela, ITipoParcelas } from '../../../Interfaces/Cobranca/TipoParcela/TipoParcelaInterface';
import Axios from '../../Config/API';
import Service from "../../Service";

export const ListarTipoParcelaService = (pag: number) => Service(
    Axios.get<ITipoParcelas>(`/cobranca/tipoparcela/listartipoparcela?pagina=${pag}`)
)

export async function CadastrarTipoParcelaService(requestBody: ITipoParcela) {
    return Service(
        Axios.post(`/cobranca/tipoparcela/inseretipoparcela`, requestBody)
    )
}

export async function DeletarTipoParcelaService(ID_TIPO_PARCELA: number) {
    return Service(
        Axios.delete(`/cobranca/tipoparcela/deletatipoparcela?IdTipoParcela=${ID_TIPO_PARCELA}`)
    )
}

export const AtualizarTipoParcelaService = (requestBody: ITipoParcela) => Service(
    Axios.put(`/cobranca/tipoparcela/atualizatipoparcela`, requestBody)
)